module.exports = __webpack_public_path__ + "img/CS-ECO13_Overview-Front_1.b9559b14.jpg";